<template>
  <div class="content-window" :class="content ? content.side : 'dark'">
    <div class="flex-wrapper">
      <div class="image-frame">
        <img
          v-show="!loading"
          :src="content ? content.url : ''"
          v-on:load="onLoad"
          :class="{ loading: loading }"
        />
        <div v-show="loading"><p>Loading...</p></div>
      </div>
      <div class="info-frame">
        <ContentInfo :content="content" class="content-info"> </ContentInfo>
      </div>
    </div>
    <router-link to="/graphic">
      <img class="close-button" src="../assets/batsu.png" />
    </router-link>
    <router-link v-if="prevUrl" :to="prevUrl" class="prev">
      <img src="../assets/back.png" />
    </router-link>
    <router-link v-if="nextUrl" :to="nextUrl" class="next">
      <img src="../assets/next.png" />
    </router-link>
  </div>
</template>
<script>
import ContentInfo from "@/components/ContentInfo.vue";

export default {
  name: "GraphicWindow",
  components: {
    ContentInfo,
  },
  methods: {
    onLoad() {
      this.loading = false;
    },
    getContent(offset = 0) {
      const contents = this.$store.state.master?.graphics;
      if (!contents) return null;
      const side = this.$route.params.side;
      const id = Number(this.$route.params.id);
      const content = contents[side].find(
        (content) => content.index == id + offset
      );
      return content;
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    content() {
      this.loading = true;
    },
  },
  computed: {
    content() {
      return this.getContent();
    },
    prevUrl() {
      const content = this.getContent(-1);
      if (content) {
        return "/graphic/" + content.side + content.index;
      } else {
        return null;
      }
    },
    nextUrl() {
      const content = this.getContent(1);
      if (content) {
        return "/graphic/" + content.side + content.index;
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content-window {
  z-index: 2;
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100% - 70px);

  &.dark {
    color: white;
    background-color: rgba(0, 0, 0, 0.932);
  }

  &.light {
    color: black;
    background-color: rgba(255, 255, 255, 0.932);
  }
}
.flex-wrapper {
  height: 100%;
  padding-right: 5%;
  padding-left: 5%;
  display: flex;
  align-items: center;
  overflow: wrap;
  @media (max-width: 1000px) {
    height: 100%;
    box-sizing: border-box;
    display: inherit;
    flex-flow: column nowrap;
    padding: {
      left: 10%;
      right: 10%;
      top: 7%;
      bottom: 7%;
    }
  }
}
.image-frame {
  flex: 3;
  align-items: flex-start;
  display: flex;
  max-width: 100%;
  height: 100%;
  box-sizing: border-box;

  @media (max-width: 1000px) {
    height: 50%;
  }
  div {
    margin: auto;
  }
  img {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;

    margin: auto;
    border-radius: 5px;
    transform: scale(0.95);

    animation-name: fadein;
    animation-duration: 0.5s;
    animation-iteration-count: 1;

    .light & {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }
    .neutral & {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }
    .dark & {
      box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    }
    &.loading {
      opacity: 0;
    }
    @media (max-width: 1000px) {
      max-height: 100%;
      height: auto;
      width: auto;
    }

    @keyframes fadein {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }
}

.info-frame {
  flex: 2;
  align-items: center;
  flex-direction: column;
  display: flex;
  padding: 2%;
  padding-top: 7%;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  @media (max-width: 1000px) {
    padding-top: 0%;
    display: inherit;
    height: 50%;
  }
}
.prev,
.next {
  position: absolute;
  top: 0;
  width: 5%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  img {
    user-select: none;
    width: 95%;
  }
  &:hover {
    transition: 0.3s;
    background-color: rgba(128, 128, 128, 0.5);
  }
  & {
    transition: 0.3s;
    background-color: rgba(128, 128, 128, 0);
  }
}
.prev {
  left: 0;
}
.next {
  left: 95%;
}

.close-button {
  position: absolute;
  user-select: none;
  width: 6%;
  height: auto;
  left: 89%;
  top: 0;
}

@media (max-width: 1000px) {
  .prev,
  .next {
    width: 10%;
  }
  .next {
    left: 90%;
  }
  .close-button {
    width: 10%;
    top: 1%;
    left: 80%;
  }
}
</style>
